( function () {
	'use strict';

	/* @ngInject */
	/* eslint-disable max-params */
	function FileInfoCtrl ( $scope, fileService, $modal, ppdFactory, Session ) {
		var self = this;

		self.loading         = false;
		self.fileType        = ppdFactory.getFileType();
		self.downloading     = false;
		self.userId          = Session.getCredentials().userId;
		self.resourceId      = ppdFactory.getResourceId();
		self.location        = ppdFactory.getLocation();
		self.viewDisabled    = ppdFactory.isViewDisabled();
		self.templatePreview = ppdFactory.isTemplatePreview();

		function successCb ( res ) {
			self.fileName    = res.data.filename;
			self.createdAt   = res.data.createdAt;
			self.description = res.data.description;
		}

		function downloadFile () {
			self.downloading = true;

			var params = {
				'type'   : self.fileType,
				'userId' : self.userId
			};

			fileService.download( self.info.id, params, self.fileName )
			.finally( function () {
				self.downloading = false;
			} );
		}

		function getFileDetails () {
			var params = {
				'type' : self.fileType
			};

			self.loading = true;

			fileService.get( self.info.id, params )
			.then( successCb )
			.finally( function () {
				self.loading = false;
			} );
		}

		function updateUploadedFiles () {
			$scope.$emit( 'pd:update:uploaded-files', self.info );
		}

		function confirmDelete () {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/ppd/files/delete-uploaded-modal.html',
				'controller'   : 'DeletePDFileCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,

				'resolve' : {
					'fileId' : function () {
						return self.info.id;
					}
				}
			} );

			modalInstance.result
			.then( function () {
				updateUploadedFiles();
				self.removeItem( self.info );
			} );
		}

		function activate () {
			getFileDetails();
		}

		self.confirmDelete = confirmDelete;
		self.downloadFile  = downloadFile;

		activate();
	}

	angular
		.module( 'app.components' )
		.controller( 'FileInfoCtrl', FileInfoCtrl );

	FileInfoCtrl.$inject = [ '$scope', 'fileService', '$modal', 'ppdFactory', 'Session' ];
} )( );
